import { defineMessages } from "react-intl";

export const orderReturnMessages = defineMessages({
  appTitle: {
    id: "rVIlBs",
    defaultMessage: "Order #{orderNumber}",
    description: "page header with order number",
  },
  pageTitle: {
    id: "rH4pi3",
    defaultMessage: "Return & replace products",
    description: "page header",
  },
});
